import { Component, OnInit } from "@angular/core";
import { NgForm } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { ClienteContatoService } from "@core/services/cliente-contato.service";
import { LeadContatoService } from "@core/services/lead-contato.service";
import { AuthenticationService } from "app/auth/service";
import { Subscription } from "rxjs";
import Swal from "sweetalert2";

@Component({
	selector: 'app-form-lead-contato',
	templateUrl: './form-lead-contato.component.html',
	styleUrls: ['./form-lead-contato.component.scss']
})
export class FormLeadContatoComponent implements OnInit {
	public leadId: number;
	public leadContatoId: number;
	public nome;
	public setor;
	public telefone;
	public email;
	public whatsapp;
	public cpf_contratante;
	public tipoContato;
	public checkboxValue = false;
	public isDefault = false;

	public basicPwdShow = false;
	public contentHeader: object;
	private routeSub: Subscription;
	public isLoading = false;
	public href;

	constructor(
		private route: ActivatedRoute,
		private clienteContatoService: ClienteContatoService,
		private _authenticationService: AuthenticationService,
		private leadContatoService: LeadContatoService,
		private _router: Router
	) {

	}

	public checkboxChange(e) {
		this.checkboxValue = !this.checkboxValue;
		if (this.checkboxValue) {
			this.isDefault = true;
		} else {
			this.isDefault = false;
		}
	}

	public submitForm(data: NgForm) {
		if (this.route.snapshot.params.id_lead_contato) {
			if (data.form.valid === true) {
				this.isLoading = true;
				this.leadContatoService
					.put(data, this.leadContatoId, this.leadId, this.isDefault)
					.subscribe(
						(res) => {
							this.isLoading = false;
							Swal.fire({
								title: "Sucesso!",
								text: "O indicador foi atualizado.",
								icon: "success",
								confirmButtonText: "Confirmar",
							}).then((result) => {
								if (result.isConfirmed) {
									this._router.navigate(["/lead/editar/" + this.leadId])
								}
							});
						},
						(error) => {
							this.isLoading = false;
							Swal.fire("Erro!", "Ocorreu um erro ao cadastrar.", "error");
						}
					);
			}
		} else {
			if (data.form.valid === true) {
				this.isLoading = true;

				let contato = {
					setor: data.form.value.setor,
					nome: data.form.value.nome,
					telefone: data.form.value.telefone,
					whatsapp: data.form.value.whatsapp,
					cpf_contratante: this.cpf_contratante,
					email: data.form.value.email,
					id_lead: this.leadId,
					isDefault: this.isDefault,
				}

				this.leadContatoService.create(contato)
					.subscribe(
						(res) => {
							this.isLoading = false;
							Swal.fire({
								title: "Sucesso!",
								text: "O item foi atualizado.",
								icon: "success",
								confirmButtonText: "Confirmar",
							}).then((result) => {
								if (result.isConfirmed) {
									this._router.navigate(["/lead/editar/" + this.leadId])
								}
							});
						},
						(error) => {
							this.isLoading = false;
							Swal.fire("Erro!", "Ocorreu um erro ao cadastrar.", "error");
						}
					);
			}
		}
	}

	ngOnInit() {
		this.href = this.route.url;
		this.leadId = this.route.snapshot.params.id_lead;
		this.leadContatoId = this.route.snapshot.params.id_lead_contato;

		if (this.href.value[2].path == "cadastro") {

			this.contentHeader = {
				headerTitle: "Cadastro Contato",
				actionButton: false,
				breadcrumb: {
					type: "",
					links: [
						{
							name: "Início",
							isLink: false,
						},
						{
							name: "Lead",
							isLink: false,
						},
						{
							name: "Contato",
							isLink: false,
						},
						{
							name: "Cadastro Contato",
							isLink: false,
						},
					],
				},
			};
		}

		if (this.href.value[2].path == "editar") {
			this.leadContatoService.findOne(this.route.snapshot.params.id_lead_contato).subscribe(
				(res) => {
					this.nome = res[0].nome;
					this.tipoContato = res[0].tipo;
					this.setor = res[0].setor;
					this.email = res[0].email;
					this.telefone = res[0].telefone;
					this.whatsapp = res[0].whatsapp;
					this.cpf_contratante = res[0].cpf_contratante;
					this.isDefault = res[0].isDefault ? true : false;
					this.checkboxValue = res[0].isDefault ? true : false;
				},
				(error) => error
			);

			this.contentHeader = {
				headerTitle: "Editar Contato",
				actionButton: false,
				breadcrumb: {
					type: "",
					links: [
						{
							name: "Início",
							isLink: false,
						},
						{
							name: "Lead",
							isLink: false,
						},
						{
							name: "Contato",
							isLink: false,
						},
						{
							name: "Editar Contato",
							isLink: false,
						},
					],
				},
			};
		}
	}

	// ngOnDestroy() {
	//   this.routeSub.unsubscribe();
	// }
}
